import supabaseClient from '../utils/supabase'

const logout = async () => {
  await supabaseClient.auth.signOut()

  localStorage.removeItem('userData')
}

export default logout
